import { render, staticRenderFns } from "./ListPayments.vue?vue&type=template&id=068c2fb6&scoped=true&"
import script from "./ListPayments.vue?vue&type=script&lang=ts&"
export * from "./ListPayments.vue?vue&type=script&lang=ts&"
import style0 from "./ListPayments.vue?vue&type=style&index=0&id=068c2fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068c2fb6",
  null
  
)

export default component.exports